export default __webpack_public_path__ + "static/media/Cerniera_DX.d3479844.svg";